export default __webpack_public_path__ + "static/media/auteuil9.77e5bc2a.jpg";